import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

function ClickHandler({ onLocationSelect }) {
  useMapEvents({
    click(e) {
      if (onLocationSelect) {
        onLocationSelect([e.latlng.lat, e.latlng.lng]);
      }
    }
  });
  return null;
}

// Flies the map to focusLocation whenever it changes
function FlyTo({ location }) {
  const map = useMap();
  useEffect(() => {
    if (location) {
      map.flyTo(location, 15, { duration: 1 });
    }
  }, [location, map]);
  return null;
}

function MapContainerComponent({ onLocationSelect, selectedLocation, focusLocation, poiMapElements }) {
  return (
    <MapContainer
      center={[35.6892, 51.3890]}
      zoom={12}
      style={{ width: '100%', height: '100%' }}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      {onLocationSelect && <ClickHandler onLocationSelect={onLocationSelect} />}
      {selectedLocation && <Marker position={selectedLocation} />}
      {focusLocation && (
        <>
          <FlyTo location={focusLocation} />
          <Marker position={focusLocation} />
        </>
      )}
      {poiMapElements}
    </MapContainer>
  );
}

export default MapContainerComponent;
